<div class="chips-container">
  @if (label) {
  <label class="chip-label">{{ label }}</label>
  }
  <mat-chip-grid
    #chipGrid
    class="input-chip-field"
    (mousedown)="onChipGridMouseDown($event)"
    (keydown)="onChipGridKeydown($event)"
    tabindex="0"
    [ngClass]="{ 'hidden-input': shouldHideInput }"
    [style.min-height.px]="minHeight"
    [class.scroll-all]="forceShowAll"
  >
    @for (chip of visibleChips; track trackByIndex(i); let i = $index) {
    <mat-chip-row
      class="chip"
      #chipItem
      [ngClass]="color === DEFAULT_COLOR ? 'primary-chip' : 'grey-chip'"
      selected
      [removable]="true"
      [attr.data-chip-index]="i"
    >
      <span class="chip-text">
        {{ chip }}
      </span>
      <mat-icon
        class="close-icon"
        matChipRemove
        (mousedown)="onRemoveIconMouseDown($event, i)"
      >
        cancel
      </mat-icon>
    </mat-chip-row>
    } @if (showMoreChip) {
    <mat-chip-row
      class="more-chip"
      (mousedown)="focusInputFromBadge()"
      (click)="focusInputFromBadge()"
      selectable="false"
      removable="false"
      role="button"
      tabindex="0"
      aria-label="Hidden chips badge; activate to focus input"
    >
      +{{ hiddenChipsCount }}
    </mat-chip-row>
    }
    <input
      [class.hidden]="shouldHideInput"
      #chipInput
      class="chips-input"
      placeholder="{{ placeholderText }}"
      [formControl]="control"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      [matChipInputAddOnBlur]="true"
      (blur)="onInputBlur()"
      (keydown)="onInputKeydown($event)"
    />
  </mat-chip-grid>
  @if (control.invalid && (control.dirty || control.touched)) {
  <div>
    @if (control.hasError('notValid')) {
    <mat-error i18n="@@InputChipsNotValidError"
      >Please enter a number from 1 to 45</mat-error
    >
    } @if (control.hasError('duplicate')) {
    <mat-error i18n="@@InputChipsDuplicateError"
      >This class has already been added to the order</mat-error
    >
    }
  </div>
  }
</div>
